import { lazy } from 'react'
import { ExtendedRouteObject } from './routes'
import { PageRoute } from './routes-behind-login/page-route'
import { PageAccess } from './routes-behind-login/routes-behind-login'

export const openPages: ExtendedRouteObject[] = [
  {
    path: PageRoute.LANDING,
    Component: lazy(
      () => import('~pages/open-pages/landing-page/landing-page'),
    ),
    handle: { disableLeftNavigation: true, pageAccess: PageAccess?.EXTERNAL },
  },
  {
    path: PageRoute.UNAUTHORIZED,
    Component: lazy(() => import('~pages/auth/unauthorized-page')),
    handle: { disableLeftNavigation: true, pageAccess: PageAccess?.EXTERNAL },
  },
  {
    path: 'callback',
    Component: lazy(() => import('../pages/auth/callback-page')),
    handle: { disableLeftNavigation: true, pageAccess: PageAccess?.EXTERNAL },
  },
  {
    path: 'contact-us',
    Component: lazy(() => import('../pages/open-pages/contact/contact')),
    handle: { disableLeftNavigation: true, pageAccess: PageAccess?.EXTERNAL },
  },
  {
    path: 'terms-and-conditions',
    Component: lazy(
      () =>
        import('../pages/open-pages/terms-and-conditions/terms-and-conditions'),
    ),
    handle: { disableLeftNavigation: true, pageAccess: PageAccess?.EXTERNAL },
  },
  {
    path: 'legal-notice',
    Component: lazy(
      () => import('../pages/open-pages/legal-notice/legal-notice'),
    ),
    handle: { disableLeftNavigation: true, pageAccess: PageAccess?.EXTERNAL },
  },
  {
    path: 'privacy-policy',
    Component: lazy(
      () => import('../pages/open-pages/privacy-policy/privacy-policy'),
    ),
    handle: { disableLeftNavigation: true, pageAccess: PageAccess?.EXTERNAL },
  },
]
